import React, { FC } from "react";
import { Tooltip } from "antd";
import { statusMetaFor } from "./statusMeta";

const MAX_SEGMENTS = 24;

interface MilestoneRailProps {
  completed: number;
  total: number;
  status?: string;
}

// Signature element — segmented program bar, one segment per phase.
// Falls back to a continuous fill beyond MAX_SEGMENTS phases.
const MilestoneRail: FC<MilestoneRailProps> = ({ completed, total, status }) => {
  const color = statusMetaFor(status).dot;
  const safeTotal = Number(total) || 0;
  const safeCompleted = Math.min(Number(completed) || 0, safeTotal);
  const title =
    safeTotal > 0
      ? `${safeCompleted} of ${safeTotal} phases complete`
      : "No phases yet";

  if (safeTotal === 0) {
    return (
      <Tooltip title={title}>
        <div className="pms-milestone-rail">
          <span className="pms-rail-seg" />
        </div>
      </Tooltip>
    );
  }

  if (safeTotal > MAX_SEGMENTS) {
    const pct = Math.round((safeCompleted / safeTotal) * 100);
    return (
      <Tooltip title={title}>
        <div className="pms-milestone-rail pms-rail-continuous">
          <div
            className="pms-rail-fill"
            style={{ width: `${pct}%`, background: color }}
          />
        </div>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={title}>
      <div className="pms-milestone-rail">
        {Array.from({ length: safeTotal }, (_, i) => (
          <span
            key={i}
            className="pms-rail-seg"
            style={i < safeCompleted ? { background: color } : undefined}
          />
        ))}
      </div>
    </Tooltip>
  );
};

export default MilestoneRail;
